module.exports = __webpack_public_path__ + "static/team-26-22e4b7e8bc10525a4e3abe4c78a9ccff.jpg";